import React from "react";

export default function Navigation() {
	return <div className="p-5">Apps page here</div>;
}
